import React from 'react';
import AccountList from './AccountList';

const CashboxAccounts = () => {
  return <AccountList baseAccountId={11} />;
};

export default CashboxAccounts;
